import { h, Component } from 'preact';

import './index.less';
import { cdnHost } from '../../../config';
import { getCatalogueTheme } from '../../lib/Theme';
import { getIdentity } from '../../lib/Identity';
import { getRequestLeadIdentity } from '../../lib/CompanyExperiments';
import {
  deleteCachedCouponData,
  fetchIncentiveCoupon,
  setDefaultCouponData
} from '../../lib/Coupon';
import { REQUEST_STATUS } from '../../lib/CacheManager';
import EventBus from '../../lib/EventBus';
import OfferForm from './offerForm';
import ExitDialogConfirmation from './exitDialogConfirmation';
import CopyCodeContainer from './copyCodeContainer';

class SpecialOfferModal extends Component {
  constructor (props) {
    super(props);
    this.INITIAL_STATE = {
      intent: false,
      couponCode: '',
      step: '1'
    };

    this.state = this.INITIAL_STATE;
    this.modalTimer = null;
  }

  setTimerToShowOffer = () => {
    setDefaultCouponData({ status: REQUEST_STATUS.PENDING });
    this.modalTimer = setTimeout(() => {
      this.setState({ intent: true });
    }, 15000);
  };

  identityModalRequested = () => {
    clearTimeout(this.modalTimer);
    deleteCachedCouponData();
    this.setState({ intent: false });
  };

  componentDidMount () {
    const leadIdentityAvailable = getRequestLeadIdentity();
    if (!leadIdentityAvailable) {
      return;
    }

    EventBus.addListener(EventBus.TYPE.SHOW_REQUEST_IDENTITY_MODAL, this.identityModalRequested);
    getIdentity()
      .then((res) => {
        if (res.phone) {
          this.fetchCouponCode();
          return;
        }

        this.setTimerToShowOffer();
      })
      .catch(() => {
        // No-op added to prevent unhandled error
      });
  }

  componentWillUnmount () {
    EventBus.removeListener(EventBus.TYPE.SHOW_REQUEST_IDENTITY_MODAL, this.identityModalRequested);
    clearTimeout(this.modalTimer);
    deleteCachedCouponData();
  }

  onClose = () => {
    this.setState({ ...this.INITIAL_STATE, intent: false });
  };

  onNoCouponRequired = () => {
    deleteCachedCouponData();
    this.onClose();
  };

  updateStep = (value) => {
    this.setState({ step: value });
  };

  fetchCouponCode = () => fetchIncentiveCoupon();

  render () {
    const { intent, step } = this.state;
    const buttonStyle = getCatalogueTheme().addToCartButton || {};

    if (!intent) {
      return null;
    }

    return (
      <div className="discount-offer-modal">
        <div className="gradient" />
        <div className="container">
          <div className="content">
            <img className="offer-logo" alt src={`${cdnHost}assets/discountGift.svg`} />
            {step === '1' && (
              <OfferForm
                updateStep={this.updateStep}
                buttonStyle={buttonStyle}
                closeDialog={() => this.setState({ intent: false })}
                setCouponCode={(code) => this.setState({ couponCode: code })}
              />
            )}
            {step === '2a' && (
              <CopyCodeContainer
                updateStep={this.updateStep}
                buttonStyle={buttonStyle}
                couponCode={this.state.couponCode}
                onClose={this.onClose}
              />
            )}
            {step === '2b' && (
              <ExitDialogConfirmation
                updateStep={this.updateStep}
                onNoCoupon={this.onNoCouponRequired}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SpecialOfferModal;
